module.exports = require("npm:@angular/core@2.0.0-rc.1/index.js");